/* shazer llanera theme: menu, cart drawer, product form */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const money = cents => {
    const fmt = (window.theme && theme.moneyFormat) || "${{amount}}";
    const amt = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt);
  };
  const esc = t => String(t == null ? "" : t).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

  /* menu */
  const burger = $("#burger"), menu = $("#menu");
  if (burger && menu) {
    const set = o => { menu.hidden = !o; burger.setAttribute("aria-expanded", o); burger.querySelector(".burger-label").textContent = o ? "close" : "menu"; document.body.style.overflow = o ? "hidden" : ""; };
    burger.addEventListener("click", () => set(menu.hidden));
    menu.addEventListener("click", e => { if (e.target.closest("a")) set(false); });
    document.addEventListener("keydown", e => { if (e.key === "Escape" && !menu.hidden) set(false); });
  }

  /* cart drawer */
  const drawer = $("#cart-drawer"), scrim = $("#cart-scrim");
  const countEls = () => $$("[data-cart-count]");
  function openCart(o) {
    if (!drawer) return;
    drawer.hidden = !o; scrim.hidden = !o; document.body.style.overflow = o ? "hidden" : "";
    if (o) $("#cart-close").focus();
  }
  function render(cart) {
    countEls().forEach(el => (el.textContent = cart.item_count));
    if (!drawer) return;
    $("#cart-subtotal").textContent = money(cart.total_price);
    $("#cart-checkout").disabled = !cart.item_count;
    $("#cart-items").innerHTML = cart.item_count ? cart.items.map(i => `
      <div class="item">
        ${i.image ? `<img src="${esc(i.image + (i.image.includes("?") ? "&" : "?") + "width=160")}" alt="">` : "<span></span>"}
        <div><p>${esc(i.product_title)}</p><small>${[i.variant_title, i.selling_plan_allocation && i.selling_plan_allocation.selling_plan.name].filter(Boolean).map(esc).join(" · ")}${i.variant_title || i.selling_plan_allocation ? " · " : ""}qty ${i.quantity}</small></div>
        <div class="end"><span>${money(i.final_line_price)}</span><a class="rm" href="${root}cart/change?id=${encodeURIComponent(i.key)}&quantity=0" data-key="${esc(i.key)}">remove</a></div>
      </div>`).join("") : `<p class="cart-empty">your cart is empty.</p>`;
  }
  async function getCart() { const r = await fetch(root + "cart.js"); return r.json(); }
  async function refresh() { try { render(await getCart()); } catch (e) {} }

  $$("[data-open-cart]").forEach(b => b.addEventListener("click", e => { if (!drawer) return; e.preventDefault(); openCart(true); refresh(); }));
  if (drawer) {
    $("#cart-close").addEventListener("click", () => openCart(false));
    scrim.addEventListener("click", () => openCart(false));
    document.addEventListener("keydown", e => { if (e.key === "Escape" && !drawer.hidden) openCart(false); });
    $("#cart-items").addEventListener("click", async e => {
      const b = e.target.closest("[data-key]"); if (!b) return;
      e.preventDefault(); b.style.pointerEvents = "none";
      const r = await fetch(root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) });
      render(await r.json());
    });
  }

  /* product form */
  const form = $("[data-product-form]");
  if (form) {
    const variants = JSON.parse($("#product-variants").textContent);
    const idInput = form.querySelector("input[name=id]");
    const addBtn = form.querySelector("[data-add]");
    const priceEl = $("[data-price]");
    const err = form.querySelector(".form-error");
    const qty = form.querySelector("input[name=quantity]");
    const syncVariant = () => {
      const opts = $$("fieldset.opt", form).map(f => (f.querySelector("input:checked") || {}).value);
      const v = variants.find(v => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <s>${money(v.compare_at_price)}</s>` : "");
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? "add to cart" : "sold out";
      const url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
    };
    $$("fieldset.opt input", form).forEach(i => i.addEventListener("change", syncVariant));
    $$("[data-step]", form).forEach(b => b.addEventListener("click", () => {
      qty.value = Math.max(1, Math.min(99, (+qty.value || 1) + (+b.dataset.step)));
    }));
    form.addEventListener("submit", async e => {
      if (!drawer) return; // no drawer: normal form post to /cart/add
      e.preventDefault();
      err.textContent = ""; addBtn.disabled = true; addBtn.textContent = "adding…";
      try {
        const r = await fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || "couldn't add this to your cart.");
        await refresh(); openCart(true); qty.value = 1;
        addBtn.textContent = "added";
      } catch (ex) { err.textContent = String(ex.message || ex).toLowerCase(); addBtn.textContent = "add to cart"; }
      setTimeout(() => { addBtn.textContent = "add to cart"; addBtn.disabled = false; }, 1200);
    });
  }

  /* collection sort */
  const sort = $("#sort-by");
  if (sort) sort.addEventListener("change", () => { const u = new URL(location.href); u.searchParams.set("sort_by", sort.value); location.href = u; });
})();
